
const rootUrl = process.env.REACT_APP_BACKEND_API_URL;

const BackendConnector = {
    fetchData: async (endpoint) => {
        try {
            const response = await fetch(`${rootUrl}${endpoint}`);
            if (!response.ok) {
                throw new Error(`HTTP error! status: ${response.status}`);
            }
            return await response.json();
        } catch (error) {
            console.error(`Error fetching data from ${endpoint}:`, error);
            throw error;
        }
    },
    postData: async (endpoint, data) => {
        try {
            const response = await fetch(`${rootUrl}${endpoint}`, {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json'
                },
                body: JSON.stringify(data),
                credentials: 'omit'
            });
            if (!response.ok) {
                throw new Error(`HTTP error! status: ${response.status}`);
            }
            return await response.json();
        } catch (error) {
            console.error(`Error posting data to ${endpoint}:`, error);
            throw error;
        }
    }
};

export default BackendConnector;